import { render, staticRenderFns } from "./StatusChangeHistory.vue?vue&type=template&id=7b46f921&"
import script from "./StatusChangeHistory.vue?vue&type=script&lang=js&"
export * from "./StatusChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports